import { PAEnvironment } from "../PA.Core/PAEnvironment";
import axios from "axios";
import { IFileOptions, IFileParameterSet } from "../PA.File.Core/PA.File.IF";
import {
    IDataIntegrationDeleteOptions,
    IDataIntegrationRefreshOptions,
    IDataIntegrationResponse,
    IFileLoaderDataIntegrationService,
} from "./FileLoaderDataIntegrationService.IF";

export class FileLoaderDataIntegrationService implements IFileLoaderDataIntegrationService {
    uploadFile(aFile: File, aFileParamSet: IFileParameterSet, aFileOptions: IFileOptions): Promise<string> {
        const self = this;
        let formData = new FormData();
        formData.append("file", aFile, aFile.name);
        let params = {
            method: "uploadFile",
            fileOptions: aFileOptions,
            fileParamSet: aFileParamSet,
        };
        return new Promise<string>((resolve, reject) => {
            let sEndPoint = <string>PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/");
            if (sEndPoint.endsWith("/")) sEndPoint += "fileLoaderUpload";
            else sEndPoint += "/fileLoaderUpload";
            axios
                .post(sEndPoint, formData, {
                    params,
                    headers: { "CONTENT-TYPE": "multipart/form-data" },
                })
                .then((resp: any) => {
                    if (resp.status == 200) {
                        var responseData = "file uploaded";
                        resolve(responseData);
                    } else {
                        reject("Unable to upload the file. ");
                    }
                })
                .catch((err: any) => {
                    reject("Unable to upload the file. " + err);
                });
        });
    }

    refreshRaw(wbDataObjectId: number, opts?: IDataIntegrationRefreshOptions): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "RefreshRaw",
            wbDataObjectId: wbDataObjectId,
            options: opts || {},
        };

        return this.makeRequest(aRequest);
    }

    refreshArchive(wbDataObjectId: number, opts?: IDataIntegrationRefreshOptions): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "RefreshArchive",
            wbDataObjectId: wbDataObjectId,
            options: opts || {},
        };

        return this.makeRequest(aRequest);
    }

    refreshManual(wbDataObjectId: number, opts?: IDataIntegrationRefreshOptions): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "RefreshManual",
            wbDataObjectId: wbDataObjectId,
            options: opts || {},
        };

        return this.makeRequest(aRequest);
    }

    deleteFile(wbStagingId: number, opts?: IDataIntegrationDeleteOptions): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "DeleteFile",
            wbStagingId: wbStagingId,
            options: opts || {},
        };

        return this.makeRequest(aRequest);
    }

    downloadManual(wbStagingId: number): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "DownloadManual",
            wbStagingId: wbStagingId,
        };

        return this.makeRequest(aRequest);
    }

    downloadRaw(wbStagingClientRawId: number, options: any): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "DownloadRaw",
            wbStagingClientRawId: wbStagingClientRawId,
            options: options,
        };

        return this.makeRequest(aRequest);
    }

    downloadArchive(wbStagingArchiveId: number, options: any): Promise<IDataIntegrationResponse> {
        let aRequest: any = {
            RequestType: "DownloadArchive",
            wbStagingArchiveId: wbStagingArchiveId,
            options: options,
        };

        return this.makeRequest(aRequest);
    }

    private makeRequest(aRequest: any): Promise<IDataIntegrationResponse> {
        return new Promise<any>((resolve, error) => {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), "/");
            if (sEndPoint.endsWith("/")) {
                sEndPoint += "fileUploaderService";
            } else {
                sEndPoint += "/fileUploaderService";
            }

            let user = PAEnvironment.getValue(PAEnvironment.UserContext).User;
            if (!("options" in aRequest)) aRequest.options = {};
            if (!("userId" in aRequest.options)) aRequest.options.userId = user.cif.WB_AUTHUSR_ID;

            axios
                .post(sEndPoint, { data: { request: aRequest } })
                .then((resp: any) => {
                    let responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }
}
